import React, { Fragment, useEffect, useState } from 'react';

import RootView from '../rootView';
import ListaPedidoWrapper from '../listaPedidoWrapper';

import { PEDIDO_STATUS } from '../../constants/status-pedido';

const Home = ({ navigation }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);

        return () => {
            setIsMounted(false);
        };
    }, []);

    return (
        <Fragment>
            {isMounted && (
                <RootView navigation={navigation}>
                    <ListaPedidoWrapper
                        idStatusPedido={`${PEDIDO_STATUS.AGUARDANDO},${PEDIDO_STATUS.RECEBIDO}`}
                        idStatusList={PEDIDO_STATUS.SEPARADO}
                    />
                </RootView>
            )}
        </Fragment>
    );
};

export default Home;
